import React from 'react';

const Show = ( {when, children} ) => Boolean( when ) && <>{children}</>

export default Show;
